module.exports = __webpack_public_path__ + "static/img/background.8b062f8b.svg";